import { Icon } from '@iconify/react';
import PropTypes from 'prop-types';

export function ShareButton({ handleClick }) {
  return (
    <button
      onClick={handleClick}
      className="inline-flex items-center gap-1 overflow-hidden rounded-xl p-2 hover:bg-indigo-300/40 hover:text-indigo-800 dark:hover:bg-indigo-900/20 dark:hover:text-indigo-100"
    >
      <Icon
        className="h-[1.3em] w-[1.3em]"
        icon="fluent:share-android-24-regular"
      />
      <div className="max-[319px]:hidden">share</div>
    </button>
  );
}

ShareButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
};
